

export const TitanFAQ = () => {
    return (
        <>
            <p><strong>Reguli generale</strong></p>
            <span>Înregistrarea la oricare dintre Princess Races este gratuită, însă pentru a participa este necesar un cont activ și validat la Princess Casino.</span>
            <span>Pentru a primi puncte, plasează pariuri câştigătoare eligibile în toate sloturile, precum și jocurile din categoria “Cazinou Virtual” pe parcursul perioadei cursei.</span>
            <span>După încheierea Cursei Titanilor, jucătorii din fruntea Clasamentului primesc câte un premiu cash.</span>
            <span>Te rugăm să consulţi Termenii și Condițiile pentru regulile specifice aplicabile.</span>
            <span>Princess Races sunt disponibile 24 de ore din 24, 7 zile din 7.</span>
            <p><strong>Cum câștig</strong></p>
            <span>Câştigătorii Cursei Titanilor sunt stabiliţi pe baza poziţiei unui jucător în Clasament la finalul fiecărei curse.</span>
            <span>În caz de egalitate, jucătorul cu cel mai mare număr de pariuri plasate va fi clasat pe poziţia mai înaltă.</span>
            <span>Pentru a intra în cursă, un jucător trebuie să adune puncte pe baza multiplicatorului fiecărei runde câștigate. De exemplu: dacă pariezi 20 RON și câștigi 50 RON, vei primi 2,5 puncte. Punctele se obțin doar la câștiguri mai mari sau egale cu miza.
</span>
            <span>Pariul minim pentru CURSA TITANILOR este de 20 RON. </span>
            <p><strong>Ce câștig</strong></p>
            <span><strong>Premii în funcție de clasament</strong>: adună cât mai multe puncte și califică-te în topul race-ului pentru un premiu cash.</span>
            <span><strong>Premii Instant</strong>:  acordate zilnic aleatoriu jucătorilor care au acumulat minim 10 puncte în ziua respectivă.</span>
        </>
    )
}